<template>
  <div>
    <loader :show="enviando"/>
    <b-row>
      <b-col sm="12" md="12">
        <b-card header-tag="header" >
          <div slot="header">
            <strong> {{ titulo }} </strong>
          </div>
          <b-row>
            <b-col sm="12" md="12">
              <b-card>

                  <b-button 
                      variant="secondary"
                      @click="regresar()">
                      Regresar
                  </b-button>

                  <item-header
                    :headerUp="header"
                    tipoItem="seccion"
                    @enviandoStart="enviando=true"
                    @enviandoStop="enviando=false"
                    @eliminarSeccion="eliminarSeccion()"
                  ></item-header>

                <!--  ========================== SECCIONES ================================ -->

                  <item-secciones
                    :seccionesUp="secciones"
                    :nombre="header.nombre"
                    tipoItem="seccion"
                    @enviandoStart="enviando=true"
                    @enviandoStop="enviando=false"
                  ></item-secciones>

                <!--  ========================== IMAGENES ================================ -->

                  <item-imagenes
                    :imagenes="imagenes"
                    tipoItem="seccion"
                    @enviandoStart="enviando=true"
                    @enviandoStop="enviando=false"
                    @nuevaImagen="nuevaImagen"
                    @eliminaImagen="eliminaImagen"
                    @imagenVisible="imagenVisible"
                  ></item-imagenes>

                  <!--  ========================== BLOQUES ================================ -->

                  <b-card-body>
                    <p v-if="bloques.length === 0"><i>No se han cargado bloques de texto...</i></p>
                    <item-bloque v-else
                      v-for="(element, index) in bloques"
                      :key="index"
                      :bloque="element"
                      tipoItem="seccion"
                      @enviandoStart="enviando=true"
                      @enviandoStop="enviando=false"
                      @eliminar="eliminarBloque(index)"
                      @bloqueVisible="bloqueVisible"
                    />
                  
                  <b-button v-if="puedeAgregarBloque"
                      variant="primary"
                      size="sm"
                      class="pull-right"
                      @click="agregarBloque()"
                      @enviandoStart="enviando=true"
                      @enviandoStop="enviando=false">
                      Agregar bloque
                  </b-button>

                  </b-card-body>

                  <!--  ========================== ARCHIVOS ================================ -->

                  <b-card-body>
                      <item-docs
                        :docs="docs"
                        :seccion="id"
                        tipoItem="seccion"
                        @enviandoStart="enviando=true"
                        @enviandoStop="enviando=false"
                        @documentoVisible="documentoVisible"
                      ></item-docs>
                  </b-card-body>

                  <b-card-body>
                      <b-button 
                            variant="secondary"
                            @click="regresar()">
                            Regresar
                        </b-button>
                  </b-card-body>

              </b-card>

            </b-col>
            
          </b-row>
        </b-card>
      </b-col>
    </b-row><!--/.row-->
  </div>
</template>

<script>

import swal from 'sweetalert'
import axios from 'axios'
import Loader from '../../Loader'
import { mapGetters } from "vuex";

import ItemHeader from './ItemHeader';
import ItemSecciones from './ItemSecciones';
import ItemImagenes from './ItemImagenes';
import ItemBloque from './ItemBloque';
import ItemDocs from './ItemDocs';

export default {
  name: 'NormaSeccion',
  components: {
   Loader,
   ItemHeader,
   ItemSecciones,
   ItemImagenes,
   ItemBloque,
   ItemDocs
  },
  computed: {
    ...mapGetters([
      "httpURL",
      "sessionToken",
      "permisos",
      "role"
    ]),
    puedeAgregarBloque(){
      if( this.role == 'administrador' || this.permisos.findIndex(x => x.numero === 134) >= 0 )
        return true;
      else
        return false;
    },
  },
  data: function () {
    return {
        titulo: this.$route.name,
        enviando: false,
        id: this.$route.params.id,
        header:{imagen:{path:null}},
        secciones:[],
        imagenes: [],
        docs:[],
        bloques:[]
    }
  },
  watch: {
    '$route'(to, from) {
        this.id = to.params.id;
        if( this.role != 'administrador' && this.permisos.findIndex(x => x.numero === 109) < 0)
            this.$router.go(-1);
        this.enviando = true;
        axios.get(this.httpURL+'/transparencia/normatividad/seccion/'+to.params.id,{headers:{token:this.sessionToken}})
                .then(res => {
                    this.header = {
                        imagen: res.data.seccion.imagen,
                        nombre: res.data.seccion.nombre,
                        descripcion: res.data.seccion.descripcion,
                        visible: res.data.seccion.visible
                    }
                    this.secciones = res.data.seccion.secciones;
                    this.imagenes = res.data.seccion.imagenes;
                    this.docs = res.data.seccion.docs;
                    this.bloques = res.data.seccion.bloques;
                    this.enviando = false;
                })
                .catch(error => {
                  if(error.response){
                    swal("Oops!",error.response.data.mensaje , "error")
                    }else if( error.request){
                      swal("Oops!",'No se pudo establecer una conexión al servidor. \nVerifique su conexión a internet.' , "error")
                    }
                    this.enviando = false;
                });
    }
  },
  created(){
    if( this.role != 'administrador' && this.permisos.findIndex(x => x.numero === 109) < 0)
        this.$router.go(-1);
      this.enviando = true;
      
      axios.get(this.httpURL+'/transparencia/normatividad/seccion/'+this.id,{headers:{token:this.sessionToken}})
              .then(res => {
             
                  this.header = {
                    imagen: res.data.seccion.imagen,
                      nombre: res.data.seccion.nombre,
                      descripcion: res.data.seccion.descripcion,
                      visible: res.data.seccion.visible
                  }
                  this.secciones = res.data.seccion.secciones;
                  this.imagenes = res.data.seccion.imagenes;
                  this.docs = res.data.seccion.docs;
                  this.bloques = res.data.seccion.bloques;
                  this.enviando = false;
              })
              .catch(error => {
                  if(error.response){
                      swal("Oops!",error.response.data.mensaje , "error")
                  }else if( error.request){
                      swal("Oops!",'No se pudo establecer una conexión al servidor. \nVerifique su conexión a internet.' , "error")
                  }
                  this.enviando = false;
              });
  },
  methods: {
    regresar(){
        this.$router.go(-1);
    },
    agregarBloque(){
      this.enviando = true;
      axios.post(this.httpURL+'/transparencia/normatividad/bloque/seccion/'+this.$route.params.id,
                {},
                {headers: {token:this.sessionToken}})
            .then(res => {
                this.enviando = false;
                this.$notify({ group: 'foo', type:"success", duration:2500, speed: 1000,
                          text: res.data.mensaje });
                this.bloques.push(res.data.bloque);
                
            })
            .catch(error => {
                this.enviando = false;
                if(error.response){
                    //console.log(error.response);
                    this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                        text: error.response.data.mensaje });
                }else if( error.request){
                    this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                        text: 'No se pudo establecer una conexión al servidor.' });
                }
            });
    },
    eliminarBloque(index){
      this.bloques.splice(index,1);
    },
    eliminarSeccion(){
      if( this.secciones.length > 0 || this.bloques.length > 0 || this.docs.length > 0)
        swal("Oops!",'Para poder eliminar la sección, es necesario que se encuentre sin contenidos.' , "info")
      else{
        swal({
                icon: 'info',
                title: 'Área protegida',
                text: 'Esta acción requiere de tu contraseña:',
                content: {
                element: "input",
                attributes: {
                placeholder: "Ingrese...",
                type: "password",
            }
            },
                closeOnClickOutside: true,
                button: {
                text: "Confirmar",
                closeModal: false,
            },
        })
        .then(password => {
            if (!password){
                swal.close();
            }else{
                this.enviando = true;
                axios.delete(this.httpURL+'/transparencia/normatividad/seccion/'+this.id,
                        {data:{password},headers: {token:this.sessionToken}})
                    .then(res => {
                        swal.close();
                        this.enviando = false;
                        this.$notify({ group: 'foo', type:"success", duration:2500, speed: 1000,
                            text: res.data.mensaje });
                        this.$router.go(-1);
                    })
                    .catch(error => {
                        this.enviando = false;
                        swal.close();
                        if(error.response){
                            this.error = error.response.data.mensaje;
                            //console.log(error.response);
                            this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                                text: error.response.data.mensaje });
                        }else if( error.request){
                            this.$notify({ group: 'foo', type:"error", duration:2500, speed: 1000,
                                text: 'No e pudo establecer una conexión al servidor.' });
                        }
                    });
            }
        });
      }
    },
    nuevaImagen(imagen){
      this.imagenes.push(imagen);
    },
    eliminaImagen(index){
      this.imagenes.splice(index,1);
      // console.log('Index '+index);
    },
    imagenVisible(data){
      let index = this.imagenes.findIndex(x=>x._id == data.img);
      this.imagenes[index].visible = data.visible;
    },
    bloqueVisible(data){
      let index = this.bloques.findIndex(x=>x._id == data.id);
      this.bloques[index].visible = data.visible;
    },
    documentoVisible(data){
      let index = this.docs.findIndex(x=>x._id == data.id);
      this.docs[index].visible = data.visible;
    }
      
  }
}
</script>

<style>
  /* IE fix */
  #card-chart-01, #card-chart-02 {
    width: 100% !important;
  }

div.show-image {
    position: relative;
    float:left;
    margin:5px;
}
div.show-image:hover img{
    opacity:0.5;
}

div.show-image:hover .edit{
    display: block;
}

.edit {
	padding-top: 0px;	
	padding-right: 0px;
	position: absolute;
	right: 1;
	top: 1;
	display: none;
}

</style>

<style>
  .quill-editor:not(.bubble) .ql-container,
  .quill-editor:not(.bubble) .ql-container .ql-editor {
    height: 10rem;
    padding-bottom: 1rem;
  }
</style>

<style lang="scss" scoped>
  .quill-editor,
  .quill-code {
    width: 100%;
    float: left;
  }
  .quill-code {
    height: auto;
    border: none;
    > .title {
      border: 1px solid #ccc;
      border-left: none;
      height: 3em;
      line-height: 3em;
      text-indent: 1rem;
      font-weight: bold;
    }
    > code {
      width: 100%;
      margin: 0;
      padding: 1rem;
      border: 1px solid #ccc;
      border-top: none;
      border-left: none;
      border-radius: 0;
      height: 30rem;
      overflow-y: auto;
    }
  }
</style>